import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { isInternalUser } from "lib/entitlements";
import { _t } from "app/i18n/i18n";

export const FaqHeader = () => (
  <Container className="my-3">
    <Row>
      <Col md={6} className="align-self-center">
        <h1 className="font-weight-bolder">{_t("FAQ")}</h1>
        {isInternalUser() && <p>{_t("For Internal Employees")}</p>}

        <h5>{_t("FAQ intro msg")}</h5>

        <p>
          {_t("FAQ support msg1")}
          <a href="mailto:grpsupport@nomura.com" className="text-primary">
            {_t("GRP Support")}
          </a>
          {_t("FAQ support msg2")}
        </p>
      </Col>
      <Col md={6} className="text-center">
        <FaqImage />
      </Col>
    </Row>
  </Container>
);

const FaqImage = () => (
  <img
    alt="FAQ"
    src={process.env.PUBLIC_URL + "/static/images/faq/faq.jpg"}
    style={{ maxHeight: "450px", maxWidth: "100%" }}
  />
);
